import { Component, ViewChild, TemplateRef, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { DynamicAuditTrailComponent } from '../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { EditorComponent } from '../editor/editor.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';


export interface QmsReportTemplateSectionFieldInterface {
  qmsReportTemplateSectionFieldVwPk: {
    reportSectionOrFieldId: number;
  };

  createdBy: number;
  updatedOn: Date;
  updatedBy: number;
  createdByUser: string;
  updatedByUser: string;
  templateId: number;
  reportSectionName: string;
  reportFieldName: string;
  reportSectionLabelName: string;
  reportFieldLabelName: string;
  reportSectionOrder: number;
  reportSectionFieldOrder: number;
  reportSectionFieldAtFullRow: string;
  reportSectionHeaderContent: string;
  reportSectionFooterContent: string;
  showOnlyIfNotNull: string;
  includeExcludeFlag: string;
  userId: number;
  operation: string;
  deleteReason: string;
}

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-qms-reporttemplate-sectionfield',
  templateUrl: './qms-reporttemplate-sectionfield.component.html',
  styleUrls: ['./qms-reporttemplate-sectionfield.component.scss']
})

export class QmsReporttemplateSectionfieldComponent implements OnInit, OnDestroy {

  templateId: any;
  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any = {};
  makeStickyColumns: any;
  dataTypeList: any = [];
  sectionList: any = [];
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  visibleGroupName: boolean = false;
  typeSearchText: any;
  groupDropdown: any = [];
  listOfGroups: any = [];
  groupIdsValues: any = [];
  pdfDetailSearchText: string = '';
  pdfDetailSearchText1: string = '';
  sectionListCR: any = [
    "Change Request",
    "Change Request Details",
    "Documents",
    "Actions",
    "Action Documents",
    "Check List",
    "Reviewer",
    "Approver",
    "Closure Reviewer",
    "Closure Approver",
    "Effectiveness Check",
    "EC Action",
    "EC Documents",
    "EC participants",
    "Extension",
    "Dependency",
    "Pre Actions",
    "Risk Management",
    "History"
  ];

  sectionListCAPA: any = [
    "CAPA",
    "CAPA Details",
    "Documents",
    "Actions",
    "Action Documents",
    "Check List",
    "Reviewer",
    "Approver",
    "Closure Reviewer",
    "Closure Approver",
    "Effectiveness Check",
    "EC Action",
    "EC Documents",
    "EC participants",
    "Extensions",
    "Dependency",
    "Pre Actions",
    "Risk Management",
    "History"
  ];

  sectionListDV: any = [
    "Deviation",
    "Deviation Details",
    "Documents",
    "Actions",
    "Action Documents",
    "Check List",
    "Investigation",
    "Investigation Persons",
    "Reviewer",
    "Approver",
    "Closure Reviewer",
    "Closure Approver",
    "Effectiveness Check",
    "EC Action",
    "EC Documents",
    "EC participants",
    "Extension",
    "Dependency",
    "Pre Actions",
    "Risk Management",
    "History"
  ];

  sectionListIN: any = [
    "Details",
    "Incident Logging",
    "Investigation",
    "Complete Incident",
    "Documents",
    "Actions",
    "Action Documents",
    "Check List",
    "Reviewer",
    "Approver",
    "Closure Reviewer",
    "Closure Approver",
    "Extension",
    "Dependency",
    "Pre Actions",
    "Risk Management",
    "History"
  ];

  sectionListQI: any = [
    "Details",
    "Quality Issue Logging",
    "Investigation",
    "Complete Quality Issue",
    "Documents",
    "Actions",
    "Action Documents",
    "Check List",
    "Reviewer",
    "Approver",
    "Closure Reviewer",
    "Closure Approver",
    "Effectiveness Check",
    "Effectiveness Check Action",
    "Effectiveness Check Document",
    "Effectiveness Check Participant",
    "Extension",
    "Dependency",
    "Pre Actions",
    "Risk Management",
    "History"

  ];

  sectionListCC: any = [
    "Complainant / Reporter Details",
    "Complaint Identification",
    "Investigation",
    "Products",
    "Final Evaluation",
    "Reimbursement",
    "Response",
    "Documents",
    "Actions",
    "Action Documents",
    "Check List",
    "Reviewer",
    "Approver",
    "Closure Reviewer",
    "Closure Approver",
    "Extension",
    "Dependency",
    "Pre Actions",
    "Risk Management",
    "History"
  ];
  sectionListOOS: any = [
    "OOS Details",
    "Location Details",
    "Description",
    "Test Details",
    "Instrument Details",
    "Observed Results",
    "Laboratory Investigations",
    "Signatories",
    "Preliminary Actions",
    "Data Evaluation",
    "Batch Disposition & Closure",
    "Documents",
    "Actions",
    "Action Documents",
    "Check List",
    "Reviewer",
    "Approver",
    "PhaseII",
    "PhaseII Reviewer",
    "PhaseII Approver",
    "PhaseIII",
    "PhaseIII Reviewer",
    "PhaseIII Approver",
    "Closure Reviewer",
    "Closure Approver",
    "Extension",
    "Dependency",
    "History"
  ];

  sectionListAU: any = [
    "Audit Details",
    "Audit Conduct Summary",
    "Questionnaire",
    "Participants",
    "Findings",
    "Follow Ups",
    "Recommendations",
    "Documents",
    "Check List",
    "Peer Review",
    "Closure Review",
    "Closure Approve",
    "Extension",
    "Dependency",
    "Risk Management",
    "History"
  ];

  sectionListAUFinding: any = [
    "Findings",
    "Documents",
  ];

  sectionListAUPlan: any = [
    "Audit Plan",
    "Questionnaire",
    "Documents"
  ];

  sectionListAUSchudule: any = [
    "Audit Schedule",
    "Documents"
  ];
  constructor(public dialog: MatDialog, public appService: AppService, public router: Router, public snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, public elem: ElementRef) {
    this.templateId = this.message.templateIdFromQmsReportTemplate;
    this.message.breadcrumbData.fourthLevel = this.message.navigatedReportTemplateName;
  }

  backToPreviousPage() {
    this.message.breadcrumbData.fourthLevel = '';
    this.router.navigate(['dashboard/qmsReportTemplate']);
  }

  ngOnInit() {
    if (this.message.groupNameFromQmsReportTemplate) {
      console.log("visibleGroupName===", 1);
      this.visibleGroupName = false;
      this.appService.getQmsGroupsByModule(
        this.message.moduleFromQmsReportTemplate
      ).subscribe((data: any) => {
        this.listOfGroups = data;
        this.selectBoxeForGroupValue();
        // find the matching group
        const selectedGroup = this.groupDropdown.find(
          (group: any) => group.displayExp === this.message.groupNameFromQmsReportTemplate
        );
        if (selectedGroup) {
          this.groupIdsValues = [selectedGroup.valueExp];
        }
      });
    } else {
      console.log("visibleGroupName===", 2);
      this.visibleGroupName = true;
      // Initialize group dropdown and fetch groups
      this.groupDropdown = [];
      this.appService.getQmsGroupsByModule(
        this.message.moduleFromQmsReportTemplate
      ).subscribe((data: any) => {
        this.listOfGroups = data;
        this.selectBoxeForGroupValue();
      });
    }
    this.isProcessing = true;
    this.getcallMethod();
  }

  // METHOD TO CHECK GROUP NAME CHANGES
  onGroupNameChange() {
    if (!this.visibleGroupName && this.message.groupNameFromQmsReportTemplate) {
      const selectedGroup = this.groupDropdown.find(
        (group: any) => group.displayExp === this.message.groupNameFromQmsReportTemplate
      );
      if (selectedGroup) {
        this.groupIdsValues = [selectedGroup.valueExp];
      }
    }
  }


  ngOnDestroy() {
    this.message.breadcrumbData.fourthLevel = this.message.navigatedReportTemplateName;
  }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize1 = 3;
  maxSize2 = 3;
  collectionSize1: number;
  collectionSize2: number;
  perPage1 = 10;
  perPage2 = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager1: any = {};
  pager2: any = {};
  pagedItems1: any[];
  pagedItems2: any[];
  error = '';
  setPage1(page1: number, targetpage1: number) {
    if (page1 !== null && page1 !== undefined && !Number.isNaN(page1)) {
      if (page1 < 1 || page1 > this.pager1.totalPages) {
        return;
      }
      if (Number.isNaN(page1)) {
        page1 = 1;
      }
      this.pager1 = this.paginationService.getPager(this.grid.length, page1, this.perPage1, targetpage1);
      this.pagedItems1 = this.grid.slice(this.pager1.startIndex, this.pager1.endIndex + 1);
    }
  }

  setPage2(page2: number, targetpage2: number) {
    if (page2 !== null && page2 !== undefined && !Number.isNaN(page2)) {
      if (page2 < 1 || page2 > this.pager2.totalPages) {
        return;
      }
      if (Number.isNaN(page2)) {
        page2 = 1;
      }
      this.pager2 = this.paginationService.getPager(this.grid.length, page2, this.perPage2, targetpage2);
      this.pagedItems2 = this.grid.slice(this.pager2.startIndex, this.pager2.endIndex + 1);
    }
  }

  paginationCall1(value: number) {
    this.perPage1 = value;
    this.setPage1(this.pager1.currentPage, 0);
  }

  paginationCall2(value: number) {
    this.perPage2 = value;
    this.setPage2(this.pager2.currentPage, 0);
  }

  setPagedorserch1(page1: number, targetpage1: number) {
    if (Number.isNaN(page1)) {
      page1 = 1;
    }
    if (this.gridTemp.length > 0) {
      this.pager1 = this.paginationService.getPager(this.gridTemp.length, page1, this.perPage2, targetpage1);
      this.pagedItems1 = this.gridTemp.slice(this.pager1.startIndex, this.pager1.endIndex + 1);
    } else {
      this.pagedItems1 = [];
    }
  }

  setPagedorserch2(page2: number, targetpage2: number) {
    if (Number.isNaN(page2)) {
      page2 = 1;
    }
    if (this.gridTemp.length > 0) {
      this.pager2 = this.paginationService.getPager(this.gridTemp.length, page2, this.perPage2, targetpage2);
      this.pagedItems2 = this.gridTemp.slice(this.pager2.startIndex, this.pager2.endIndex + 1);
    } else {
      this.pagedItems2 = [];
    }
  }

  tempFieldColumnArray: any = [];
  tempColumnsListArray: any = [];
  tempGridData: any = [];

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      }, error: (error) => {
        console.log(error);
      }
    })
    this.isProcessing = false;

  }
  htmlContent: any;
  getcallMethod() {
    this.isProcessing = true;
    this.grid = [];
    const data = {

      gridName: this.selectedReportSectionRowData == undefined ? "REPORT_TEMPLATE_SECTION" : "REPORT_TEMPLATE_SECTION_FIELD"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";


        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: this.selectedReportSectionRowData == undefined ? "QMS_REPORT_TEMPLATE_SECTION_VW" : "QMS_REPORT_TEMPLATE_SECTION_FIELD_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          templateIdFromQmsReportTemplate: this.message.templateIdFromQmsReportTemplate,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          reportSectionNameFromQmsReportTemplateSection: this.selectedReportSectionRowData == undefined ? null : this.selectedReportSectionRowData.REPORT_SECTION_NAME
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(`${size}px`);
            }

            let y = 0;
            while (y < this.columnLists.columnsListarray.length) {
              const currentColumn = this.columnLists.columnsListarray[y];
              if (this.columnLists.invisibleColumnarray.includes(currentColumn)) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              } else {
                y++;
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const gridItem of this.grid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    const colName = dataType.columnName;
                    gridItem[colName] = gridItem[colName] === "Y";
                  }
                }
              }

              if (this.selectedReportSectionRowData == undefined) {
                this.calculateTotalPages = this.collectionSize1 / this.perPage1;
                this.setPage1(1, 0);
                this.pager1.totalPages = undefined;
              } else {
                this.calculateTotalPages = this.collectionSize2 / this.perPage2;
                this.setPage2(1, 0);
                this.pager2.totalPages = undefined;
              }

            });
            this.message.gridList = this.grid;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);

            if (this.selectedReportSectionRowData == undefined) {
              this.tempFieldColumnArray = this.columnLists.fieldColumnarray;
              this.tempColumnsListArray = this.columnLists.columnsListarray1;
              this.collectionSize1 = this.grid.length;
              this.tempGridData = this.grid;
            } else {
              this.collectionSize2 = this.grid.length;
            }
            this.dynamicLabelCall();
            this.dynamicSectionlist();
            this.dynamicFieldCall(this.selectedReportSectionRowData.REPORT_SECTION_NAME, this.message.moduleFromQmsReportTemplate);
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    const isNewSection = this.selectedReportSectionRowData === undefined;

    let updatedItems: any[];

    if (filter) {
      updatedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    } else {
      const activePager = isNewSection ? this.pager1 : this.pager2;
      updatedItems = this.grid.slice(activePager.startIndex, activePager.endIndex + 1);
    }

    if (isNewSection) {
      this.pagedItems1 = updatedItems;
    } else {
      this.pagedItems2 = updatedItems;
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      if (this.selectedReportSectionRowData == undefined) {
        this.pager1 = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage1, 0);
        this.pagedItems1 = this.gridTemp.slice(this.pager1.startIndex, this.pager1.endIndex + 1);
      } else {
        this.pager2 = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage2, 0);
        this.pagedItems2 = this.gridTemp.slice(this.pager2.startIndex, this.pager2.endIndex + 1);
      }

    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }

      if (this.selectedReportSectionRowData == undefined) {
        this.setPagedorserch1(1, 0);
      } else {
        this.setPagedorserch2(1, 0);
      }
    }
  }

  focusEmpty() {
    console.log();
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    if (this.selectedReportSectionRowData == undefined) {
      this.setPage1(1, 0);
    } else {
      this.setPage2(1, 0);
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';

          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }
  selectedCount: number = 0;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  sectionFieldChildCheckBoxs: boolean = false;
  // parentCheckBox: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    this.parentCheckBox = e.target.checked;

    this.grid.forEach((row: any) => {
      row.sectionFieldChildCheckBoxs = this.parentCheckBox;
    });

    this.selectedCount = this.parentCheckBox ? this.grid.length : 0;
    this.visibleAuditTrail = this.parentCheckBox;
  }

  updateParentCheckboxState() {
    this.parentCheckBox = this.grid.every(
      (item: any) => item.sectionFieldChildCheckBoxs
    );
  }

  sectionFieldDataGridChildCheckBoxChecked(e: any, row: any, idx: number) {
    row.sectionFieldChildCheckBoxs = e.target.checked;

    this.selectedCount = this.grid.filter((item: any) => item.sectionFieldChildCheckBoxs).length;
    this.visibleAuditTrail = this.selectedCount > 0;

    this.auditTrail.refNo = e.target.checked ? row.REPORT_SECTION_OR_FIELD_ID : null;

    this.updateParentCheckboxState();
  }






  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    list.childCheckBoxs = e.target.checked;

    if (e.target.checked) {
      this.auditTrail.refNo = list.REPORT_SECTION_OR_FIELD_ID;
    }

    this.selectedCount = this.grid.filter((item: any) => item.childCheckBoxs).length;

    this.parentCheckBox = this.grid.every((item: any) => item.childCheckBoxs);
    this.visibleAuditTrail = this.grid.some((item: any) => item.childCheckBoxs);

    this.priviousSelectedValue = idx;
  }

  refreshGridData() {
    this.isProcessing = true;
    this.parentCheckBox = false;
    this.getcallMethod();
  }
  clearAllSelections() {
    this.parentCheckBox = false;
    this.grid.forEach((item: any) => {
      item.childCheckBoxs = false;
      item.sectionFieldChildCheckBoxs = false;
    });
    this.selectedCount = 0;
    this.visibleAuditTrail = false;
  }

  multiDelete() {
    this.operationFlag = 'MULTI_DELETE';
    this.popupDataTitle.title = "Multiple Record Delete";
    if (this.qmsReportTemplateSectionFieldData.deleteReason != undefined) {
      this.qmsReportTemplateSectionFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }
  qmsReportTemplateSectionFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('qmsReportFieldGridPopup', { static: true }) qmsReportFieldGridPopup: TemplateRef<any>;

  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleQmsReportFieldGridPopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },

  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  radioOptions = [
    { id: 1, label: 'Section' },
    { id: 2, label: 'Field' }
  ];

  reportTemplateDetails: any = [];
  radioOptionChangeEvent() {
    if (this.qmsReportTemplateSectionFieldData.radioOption == 1) {
      this.isProcessing = true;
      this.appService.getQmsReportTemplateSectionFieldsByOrgIdAndTemplateId(this.templateId).subscribe((data: any) => {
        this.reportTemplateDetails = data;
        if (this.reportTemplateDetails.length > 0) {
          this.selectBoxForSectionName();
        } else {
          this.isProcessing = false;
          this.qmsReportTemplateSectionFieldData.radioOption = 1;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: undefined,
            data: {
              message: "Please ensure the inclusion of a Section before adding Fields",
              type: 'Sorry !',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }
        this.isProcessing = false;
      })
    }
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  dropDownDataForSectionName: any = [];

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };

  sectionNameListDropdown: any = [];
  tempReportSectionLabelName: any;

  selectBoxForSectionName() {
    this.sectionNameListDropdown = [];
    for (const detail of this.reportTemplateDetails) {
      this.sectionNameListDropdown = this.sectionNameListDropdown.concat({
        valueExp: detail.reportSectionName,
        displayExp: detail.reportSectionName
      });
    }
  }

  reportsectionNameValue: any;
  reportSectionOrderValue: any;
  reportFieldNameValue: any;
  reportSectionFieldOrderValue: any;
  reportSectionLabelNameValue: any;
  reportFieldLabelNameValue: any;

  reportSectionNameRequiredMsg: any;
  reportSectionOrderRequiredMsg: any;
  reportFieldNameRequiredMsg: any;
  reportSectionFieldOrderRequiredMsg: any;
  reportSectionLableNameRequiredMsg: any;
  reportFieldLabelNameRequiredMsg: any;
  updateReqMsg: any;
  updateReq: any;

  fieldValidation() {
    this.reportsectionNameValue = document.getElementById('reportSectionName') as HTMLInputElement;
    this.reportSectionOrderValue = document.getElementById('reportSectionOrder') as HTMLInputElement;
    this.reportFieldNameValue = document.getElementById('reportFieldName') as HTMLInputElement;
    this.reportSectionFieldOrderValue = document.getElementById('reportSectionFieldOrder') as HTMLInputElement;
    this.reportSectionLabelNameValue = document.getElementById('reportSectionLabelName') as HTMLInputElement;
    this.reportFieldLabelNameValue = document.getElementById('reportFieldLabelName') as HTMLInputElement;

    this.reportSectionNameRequiredMsg = document.getElementById('reportSectionName-required-msg') as HTMLInputElement;
    this.reportSectionOrderRequiredMsg = document.getElementById('reportSectionOrder-required-msg') as HTMLInputElement;
    this.reportFieldNameRequiredMsg = document.getElementById('reportFieldName-required-msg') as HTMLInputElement;
    this.reportSectionFieldOrderRequiredMsg = document.getElementById('reportSectionFieldOrder-required-msg') as HTMLInputElement;
    this.reportSectionLableNameRequiredMsg = document.getElementById('reportSectionLabelName-required-msg') as HTMLInputElement;
    this.reportFieldLabelNameRequiredMsg = document.getElementById('reportFieldLabelName-required-msg') as HTMLInputElement;
    this.updateReqMsg = document.getElementById('update-required-msg') as HTMLInputElement;
    this.updateReq = document.getElementById('update-text') as HTMLInputElement;

    if (this.selectedReportSectionRowData == undefined) {
      if (this.reportsectionNameValue.value == "" || this.reportsectionNameValue.value == null || this.reportsectionNameValue.value == undefined) {
        this.reportsectionNameValue.style.border = '1px solid red';
        this.reportSectionNameRequiredMsg.style.display = 'block';
      } else {
        this.reportsectionNameValue.style.border = 'none';
        this.reportSectionNameRequiredMsg.style.display = 'none';
      }

      if (this.reportSectionOrderValue.value == "" || this.reportSectionOrderValue.value == null || this.reportSectionOrderValue.value == undefined) {
        this.reportSectionOrderValue.style.border = '1px solid red';
        this.reportSectionOrderRequiredMsg.style.display = 'block';
      } else {
        this.reportSectionOrderValue.style.border = 'none';
        this.reportSectionOrderRequiredMsg.style.display = 'none';
      }

      if (this.reportSectionLabelNameValue.value == "" || this.reportSectionLabelNameValue.value == null || this.reportSectionLabelNameValue.value == undefined) {
        this.reportSectionLabelNameValue.style.border = '1px solid red';
        this.reportSectionLableNameRequiredMsg.style.display = 'block';
      } else {
        this.reportSectionLabelNameValue.style.border = 'none';
        this.reportSectionLableNameRequiredMsg.style.display = 'none';
      }
    }

    if (this.selectedReportSectionRowData != undefined) {


      const reportFieldNameElement = document.getElementById('reportFieldName') as HTMLInputElement;
      const reportFieldNameMatSelect = document.querySelector('mat-select#reportFieldName') as HTMLElement;

      if (!this.qmsReportTemplateSectionFieldData.reportFieldName || this.qmsReportTemplateSectionFieldData.reportFieldName === '') {
        if (reportFieldNameElement) {
          reportFieldNameElement.style.border = '1px solid red';
        }
        if (reportFieldNameMatSelect) {
          reportFieldNameMatSelect.style.border = '1px solid red';
        }
        this.reportFieldNameRequiredMsg.style.display = 'block';
      } else {
        if (reportFieldNameElement) {
          reportFieldNameElement.style.border = 'none';
        }
        if (reportFieldNameMatSelect) {
          reportFieldNameMatSelect.style.border = 'none';
        }
        this.reportFieldNameRequiredMsg.style.display = 'none';
      }

      if (this.reportFieldLabelNameValue.value) {
        this.reportFieldLabelNameValue.style.border = 'none';
        this.reportFieldLabelNameRequiredMsg.style.display = 'none';
      } else {
        this.reportFieldLabelNameValue.style.border = '1px solid red';
        this.reportFieldLabelNameRequiredMsg.style.display = 'block';
      }

      if (this.reportSectionFieldOrderValue.value) {
        this.reportSectionFieldOrderValue.style.border = 'none';
        this.reportSectionFieldOrderRequiredMsg.style.display = 'none';
      } else {
        this.reportSectionFieldOrderValue.style.border = '1px solid red';
        this.reportSectionFieldOrderRequiredMsg.style.display = 'block';
      }
    }

   if (this.visibleEditButton) {
    if (this.updateReq && this.updateReqMsg) {
      if (this.qmsReportTemplateSectionFieldData.updateReason) {
        this.updateReq.style.border = 'none';
        this.updateReqMsg.style.display = 'none';
      } else {
        this.updateReq.style.border = '1px solid red';
        this.updateReqMsg.style.display = 'block';
      }
    }
  }
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    let flag = true;
    if (this.selectedReportSectionRowData == undefined) {
      this.popupDataTitle.title = "Create QMS Report Template Section";
      if (!this.sectionList.length) {
        flag = false;
        setTimeout(() => this.triggerSnackBar('All Sections Added'));
      }
    } else {
      this.popupDataTitle.title = "Create " + this.reportFieldTooltipTitle;
      if (!this.columnListDropdown.length) {
        flag = false;
        setTimeout(() => this.triggerSnackBar('All Fields Added'));
      }
    }

    if (flag) {
      this.groupIdsValues = [];
      this.qmsReportTemplateSectionFieldData.groupIds = null;
      this.qmsReportTemplateSectionFieldData.radioOption = 1;
      this.qmsReportTemplateSectionFieldData.reportFieldName = '';
      this.qmsReportTemplateSectionFieldData.reportSectionName = '';
      this.qmsReportTemplateSectionFieldData.reportSectionLabelName = '';
      this.qmsReportTemplateSectionFieldData.reportFieldLabelName = '';
      this.qmsReportTemplateSectionFieldData.reportSectionOrder = '';
      this.qmsReportTemplateSectionFieldData.reportSectionFieldOrder = '';
      this.qmsReportTemplateSectionFieldData.reportSectionFieldAtFullRow = false;
      this.qmsReportTemplateSectionFieldData.reportSectionHeaderContent = '';
      this.qmsReportTemplateSectionFieldData.reportSectionFooterContent = '';
      this.qmsReportTemplateSectionFieldData.showOnlyIfNotNull = false;
      this.qmsReportTemplateSectionFieldData.includeExcludeFlag = false;
      this.qmsReportTemplateSectionFieldData.isFlexiField = false;
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    }
  }

  triggerSnackBar(message: any) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: undefined,
      data: {
        message,
        type: 'Notice',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel || this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  previousData: any;
  previousDataReportSectionOrFieldId: any;
  getQmsReportTemplateSectionFieldVwDetails: any = [];
  filteredSectionDropDownValue: any = [];
  openEditPopup(editRowData: any, editFlag: boolean, cell: any) {
    if (cell == 0) {
      this.isProcessing = true;
      this.previousData = editRowData;
      this.qmsReportTemplateSectionFieldData.updateReason = null;
      this.visibleReasonForUpdateField = true;
      this.qmsReportTemplateSectionFieldData.radioOption = 1;

      if (editFlag) {
        this.visibleAddButton = false;
        this.visibleEditButton = true;
        this.operationFlag = 'EDIT';
      } else {
        this.visibleAddButton = false;
        this.visibleEditButton = false;
        this.popupDataTitle.title = "Info";
      }

      if (this.selectedReportSectionRowData == undefined) {
        this.popupDataTitle.title = "Update QMS Report Template Section";
        this.previousDataReportSectionOrFieldId = editRowData.REPORT_SECTION_OR_FIELD_ID;
        this.appService.getQmsReportTemplateSectionVwData(this.previousData.REPORT_SECTION_OR_FIELD_ID).subscribe({
          next: (response1: any) => {
            console.log(response1, "=response1");
            this.sectionList.push({ valueExp: response1.reportSectionName, displayExp: response1.reportSectionName });
            this.getQmsReportTemplateSectionFieldVwDetails = response1;
            this.qmsReportTemplateSectionFieldData.reportSectionName = response1.reportSectionName;
            this.qmsReportTemplateSectionFieldData.reportSectionOrder = response1.reportSectionOrder;
            this.qmsReportTemplateSectionFieldData.reportSectionLabelName = response1.reportSectionLabelName;
            this.qmsReportTemplateSectionFieldData.reportSectionHeaderContent = response1.reportSectionHeaderContent;
            this.qmsReportTemplateSectionFieldData.reportSectionFooterContent = response1.reportSectionFooterContent;
            this.groupIdsValues = response1.groupIds ? response1.groupIds.split(",").map(Number) : null;
            this.qmsReportTemplateSectionFieldData.isFlexiField = response1.isFlexiField == "Y";
            console.log("this.groupIdsValues=", this.groupIdsValues);
            console.log("this.qmsReportTemplateSectionFieldData.isFlexiField=", this.qmsReportTemplateSectionFieldData.isFlexiField);
            this.isProcessing = false;
            this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        })
      }
    }
  }

  openEditPopup2(editRowData: any) {
    console.log(editRowData);
    this.isProcessing = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';



    if (this.selectedReportSectionRowData != undefined) {
      this.popupDataTitle.title = "Update " + this.reportFieldTooltipTitle;
      this.previousDataReportSectionOrFieldId = editRowData.REPORT_SECTION_OR_FIELD_ID;
      this.appService.getQmsReportTemplateSectionFieldVwData(editRowData.REPORT_SECTION_OR_FIELD_ID).subscribe({
        next: (response2: any) => {
          console.log("response2=", response2);
          this.columnListDropdown.push({ valueExp: response2.reportFieldName, displayExp: response2.reportFieldName });
          this.qmsReportTemplateSectionFieldData.reportSectionName = response2.reportSectionName;
          this.qmsReportTemplateSectionFieldData.reportSectionLabelName = response2.reportSectionLabelName;
          this.qmsReportTemplateSectionFieldData.reportFieldName = response2.reportFieldName;
          this.qmsReportTemplateSectionFieldData.reportFieldLabelName = response2.reportFieldLabelName;
          this.qmsReportTemplateSectionFieldData.reportSectionOrder = response2.reportSectionOrder;
          this.qmsReportTemplateSectionFieldData.reportSectionFieldOrder = response2.reportSectionFieldOrder;
          this.qmsReportTemplateSectionFieldData.reportSectionFieldAtFullRow = response2.reportSectionFieldAtFullRow == "Yes";
          console.log(response2.reportSectionHeaderContent, "===");
          console.log(response2.reportSectionFooterContent, "===");
          this.qmsReportTemplateSectionFieldData.reportSectionHeaderContent = response2.reportSectionHeaderContent;
          this.qmsReportTemplateSectionFieldData.reportSectionFooterContent = response2.reportSectionFooterContent;
          this.qmsReportTemplateSectionFieldData.showOnlyIfNotNull = response2.showOnlyIfNotNull == "Y";
          this.qmsReportTemplateSectionFieldData.includeExcludeFlag = response2.includeExcludeFlag == "Y";
          this.qmsReportTemplateSectionFieldData.isFlexiField = response2.isFlexiField == "Y";
          this.groupIdsValues = response2.groupIds ? response2.groupIds.split(",").map(Number) : null;
          let gIds = null;
          let module = this.message.moduleFromQmsReportTemplate;
          if (this.groupIdsValues) {
            if (this.groupIdsValues.length != 0) {
              for (let i = 0; i < this.groupIdsValues.length; i++) {
                if (i == 0) {
                  gIds = this.groupIdsValues[i].toString();
                } else {
                  gIds = gIds + "," + this.groupIdsValues[i].toString();
                }
              }
            }
          }


          if (this.qmsReportTemplateSectionFieldData.isFlexiField) {
            const data = {
              moduleName: module,
              groupId: gIds ?? '0',
            };
            this.isProcessing = true;
            this.appService.getreorderGirdColumnListForFlexiField(data).subscribe({
              next: (data: any) => {
                this.columnNameList = data;
                this.selectBoxeForColumnsValueFlexiFields();
                this.qmsReportTemplateSectionFieldData.reportFieldName = response2.reportFieldName
                console.log("this.columnNameList=", this.columnNameList);
                this.isProcessing = false;
              }, error: (error: any) => {
                this.isProcessing = false;
              }
            });
            console.log("this.groupIdsValues=", this.groupIdsValues);
            console.log("this.qmsReportTemplateSectionFieldData.isFlexiField=", this.qmsReportTemplateSectionFieldData.isFlexiField);

          }
          this.isProcessing = false;
          this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    }
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  updateData: any = {};
  async addAndEditFunction(qmsReportTemplateSectionFieldData: any) {
    this.isProcessing = true;
    let reportSectionHeaderContent;
    let reportSectionFooterContent;
    if (this.selectedReportSectionRowData?.PRIM_IDENTIFIER != undefined) {
      reportSectionHeaderContent = await this.getClobValue(this.selectedReportSectionRowData['PRIM_IDENTIFIER'], 'REPORT_SECTION_HEADER_CONTENT');
      reportSectionFooterContent = await this.getClobValue(this.selectedReportSectionRowData['PRIM_IDENTIFIER'], 'REPORT_SECTION_FOOTER_CONTENT');
    }

    const isNewSectionInvalid =
      this.selectedReportSectionRowData === undefined &&
      (this.qmsReportTemplateSectionFieldData.reportSectionName === '' ||
        this.qmsReportTemplateSectionFieldData.reportSectionOrder === '' ||
        this.qmsReportTemplateSectionFieldData.reportSectionLabelName === '' ||
        (this.visibleEditButton && !this.qmsReportTemplateSectionFieldData.updateReason));

 const isExistingSectionInvalid =
  this.selectedReportSectionRowData !== undefined &&
  (!this.qmsReportTemplateSectionFieldData.reportFieldName ||
    this.qmsReportTemplateSectionFieldData.reportFieldName === '' ||
    !this.qmsReportTemplateSectionFieldData.reportSectionFieldOrder ||
    this.qmsReportTemplateSectionFieldData.reportSectionFieldOrder === '' ||
    (this.visibleEditButton && !this.qmsReportTemplateSectionFieldData.updateReason)); 

    if (isNewSectionInvalid || isExistingSectionInvalid) {
      this.isProcessing = false;
      this.fieldValidation();
    } else {
      if (this.operationFlag == 'ADD') {

        if (this.groupIdsValues.length) {
          this.qmsReportTemplateSectionFieldData.groupIds = null;
          for (const [index, groupId] of this.groupIdsValues.entries()) {
            this.qmsReportTemplateSectionFieldData.groupIds += groupId;
            this.qmsReportTemplateSectionFieldData.groupIds += index === this.groupIdsValues.length - 1 ? "" : ",";
          }
        } else {
          this.qmsReportTemplateSectionFieldData.groupIds = null;
        }
        const fallbackHeader = qmsReportTemplateSectionFieldData.reportSectionHeaderContent === 'htmlClobView'
          ? " "
          : qmsReportTemplateSectionFieldData.reportSectionHeaderContent;

        const fallbackFooter = qmsReportTemplateSectionFieldData.reportSectionFooterContent === 'htmlClobView'
          ? " "
          : qmsReportTemplateSectionFieldData.reportSectionFooterContent;

        const isNewSection = this.selectedReportSectionRowData === undefined;
        let data = {
          templateId: this.message.templateIdFromQmsReportTemplate,
          // Report Section Fields.
          reportFieldName: qmsReportTemplateSectionFieldData.reportFieldName,
          reportFieldLabelName: qmsReportTemplateSectionFieldData.reportFieldLabelName,
          reportSectionFieldOrder: qmsReportTemplateSectionFieldData.reportSectionFieldOrder,
          reportSectionFieldAtFullRow: qmsReportTemplateSectionFieldData.reportSectionFieldAtFullRow ? "Yes" : "No",
          showOnlyIfNotNull: qmsReportTemplateSectionFieldData.showOnlyIfNotNull ? "Y" : "N",
          includeExcludeFlag: qmsReportTemplateSectionFieldData.includeExcludeFlag ? "Y" : "N",
          isFlexiField: qmsReportTemplateSectionFieldData.isFlexiField ? "Y" : "N",
          groupIds: qmsReportTemplateSectionFieldData.isFlexiField ? qmsReportTemplateSectionFieldData.groupIds ?? null : null,
          reportSectionName: this.selectedReportSectionRowData == undefined ? qmsReportTemplateSectionFieldData.reportSectionName : this.selectedReportSectionRowData.REPORT_SECTION_NAME,
          reportSectionLabelName: this.selectedReportSectionRowData == undefined ? qmsReportTemplateSectionFieldData.reportSectionLabelName : this.selectedReportSectionRowData.REPORT_SECTION_LABEL_NAME,
          reportSectionOrder: this.selectedReportSectionRowData == undefined ? qmsReportTemplateSectionFieldData.reportSectionOrder : this.selectedReportSectionRowData.REPORT_SECTION_ORDER,
          reportSectionHeaderContent: isNewSection ? fallbackHeader : reportSectionHeaderContent,
          reportSectionFooterContent: isNewSection ? fallbackFooter : reportSectionFooterContent,
        }
        this.appService.createQmsReportTemplateSectionField(data).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.ngOnInit();
            }
            this.isProcessing = false;
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: this.displayResultType == 'S' ? 5000 : undefined,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }, error: (error) => {
            this.isProcessing = false;
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            throw error;
          }
        });
      } else {
        delete qmsReportTemplateSectionFieldData.createdOn;
        delete qmsReportTemplateSectionFieldData.updatedOn;
        let editData = {
          qmsReportTemplateSectionFieldVwPk: {

          },

          templateId: this.message.templateIdFromQmsReportTemplate,
        }
        if (this.groupIdsValues) {
          if (this.groupIdsValues.length) {
            this.qmsReportTemplateSectionFieldData.groupIds = null;
            for (const [index, groupId] of this.groupIdsValues.entries()) {
              this.qmsReportTemplateSectionFieldData.groupIds += groupId;
              this.qmsReportTemplateSectionFieldData.groupIds += index === this.groupIdsValues.length - 1 ? "" : ",";
            }
          } else {
            this.qmsReportTemplateSectionFieldData.groupIds = null;
          }
        } else {
          this.qmsReportTemplateSectionFieldData.groupIds = null;
        }


        if (this.selectedReportSectionRowData) {
          this.updateData = {
            ...editData,
            qmsReportTemplateSectionFieldVwPk: {
              reportSectionOrFieldId: this.previousDataReportSectionOrFieldId,
            },
            // Report Section.
            reportSectionName: this.selectedReportSectionRowData.REPORT_SECTION_NAME,
            reportSectionLabelName: this.selectedReportSectionRowData.REPORT_SECTION_LABEL_NAME,
            reportSectionOrder: this.selectedReportSectionRowData.REPORT_SECTION_ORDER,
            reportSectionHeaderContent: this.selectedReportSectionRowData.REPORT_SECTION_HEADER_CONTENT == 'htmlClobView' ? " " : this.selectedReportSectionRowData.REPORT_SECTION_HEADER_CONTENT,
            reportSectionFooterContent: this.selectedReportSectionRowData.REPORT_SECTION_FOOTER_CONTENT == 'htmlClobView' ? " " : this.selectedReportSectionRowData.REPORT_SECTION_FOOTER_CONTENT,
            groupIds: qmsReportTemplateSectionFieldData.isFlexiField ? this.qmsReportTemplateSectionFieldData.groupIds ?? null : null,
            // Report Section Fields.
            reportFieldName: qmsReportTemplateSectionFieldData.reportFieldName,
            reportFieldLabelName: qmsReportTemplateSectionFieldData.reportFieldLabelName,
            reportSectionFieldOrder: qmsReportTemplateSectionFieldData.reportSectionFieldOrder,
            reportSectionFieldAtFullRow: qmsReportTemplateSectionFieldData.reportSectionFieldAtFullRow ? "Yes" : "No",
            showOnlyIfNotNull: qmsReportTemplateSectionFieldData.showOnlyIfNotNull ? "Y" : "N",
            includeExcludeFlag: qmsReportTemplateSectionFieldData.includeExcludeFlag ? "Y" : "N",
            isFlexiField: qmsReportTemplateSectionFieldData.isFlexiField ? "Y" : "N",
            updateReason: qmsReportTemplateSectionFieldData.updateReason ? qmsReportTemplateSectionFieldData.updateReason : null,

          }
        } else {
          this.updateData = {
            ...editData,
            qmsReportTemplateSectionFieldVwPk: {
              reportSectionOrFieldId: this.previousDataReportSectionOrFieldId,
            },
            reportSectionName: this.qmsReportTemplateSectionFieldData.reportSectionName,
            reportSectionLabelName: this.qmsReportTemplateSectionFieldData.reportSectionLabelName,
            reportSectionOrder: this.qmsReportTemplateSectionFieldData.reportSectionOrder,
            reportSectionHeaderContent: this.qmsReportTemplateSectionFieldData.reportSectionHeaderContent == 'htmlClobView' ? " " : this.qmsReportTemplateSectionFieldData.reportSectionHeaderContent,
            reportSectionFooterContent: this.qmsReportTemplateSectionFieldData.reportSectionFooterContent == 'htmlClobView' ? " " : this.qmsReportTemplateSectionFieldData.reportSectionFooterContent,
            groupIds: this.qmsReportTemplateSectionFieldData.isFlexiField ? this.qmsReportTemplateSectionFieldData.groupIds ?? null : null,
            isFlexiField: this.qmsReportTemplateSectionFieldData.isFlexiField ? "Y" : "N",
            updateReason: qmsReportTemplateSectionFieldData.updateReason ? qmsReportTemplateSectionFieldData.updateReason : null,

          }
        }

        console.log('Update Call - ', this.updateData);
        this.appService.updateQmsReportTemplateSectionField(this.updateData).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.ngOnInit();
            }
            this.isProcessing = false;
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: this.displayResultType == 'S' ? 5000 : undefined,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    if (this.operationFlag == 'EDIT' || this.popupDataTitle.title == "Info") {
      console.log('...... REMOVING')
      if (this.selectedReportSectionRowData == undefined) {
        this.removeSection(this.qmsReportTemplateSectionFieldData.reportSectionName);
      } else {
        this.removeFields(this.qmsReportTemplateSectionFieldData.reportFieldName);
      }
    }
    this.visibleAddAndEditPopup.close();
  }

  removeSection(name: string) {
    this.sectionList = this.sectionList.filter(
      (section: any) => section.valueExp !== name
    );
  }

  removeFields(name: string) {
    this.columnListDropdown = this.columnListDropdown.filter(
      (field: any) => field.valueExp !== name
    );
  }




  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteQmsReportSectionOrFieldId: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    if (this.selectedReportSectionRowData == undefined) {
      this.popupDataTitle.title = "Delete QMS Report Template Section";
    } else {
      this.popupDataTitle.title = "Delete " + this.reportFieldTooltipTitle;
    }
    this.deleteQmsReportSectionOrFieldId = deleteRowData.REPORT_SECTION_OR_FIELD_ID;
    if (this.qmsReportTemplateSectionFieldData.deleteReason != undefined) {
      this.qmsReportTemplateSectionFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFiledValue: any;
  deleteFunction(qmsReportTemplateSectionFieldData: any) {
    console.log("qmsReportTemplateSectionFieldData=" + this.message.templateIdFromQmsReportTemplate);
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      qmsReportTemplateSectionFieldData.qmsReportTemplateSectionFieldVwPk = {
        reportSectionOrFieldId: this.deleteQmsReportSectionOrFieldId,
      }
      qmsReportTemplateSectionFieldData.templateId = this.message.templateIdFromQmsReportTemplate;
      qmsReportTemplateSectionFieldData.deleteReason = this.qmsReportTemplateSectionFieldData.deleteReason;
      this.appService.deleteQmsReportTemplateSectionField(qmsReportTemplateSectionFieldData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleDeletePopup.close();
            this.ngOnInit();
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, error: (error) => {
          this.isProcessing = false;
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          throw error;
        }
      });
    }
  }


  multiDeleteFunction() {
    console.log("templateId =", this.message.templateIdFromQmsReportTemplate);
    this.isProcessing = true;

    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;

    if (this.deleteFiledValue.value === '') {
      this.deleteValidation();
      this.isProcessing = false;
      return;
    }

    const selectedItems = this.grid.filter((item: any) => item.childCheckBoxs || item.sectionFieldChildCheckBoxs);

    if (selectedItems.length === 0) {
      this.isProcessing = false;
      return;
    }

    let completed = 0;

    selectedItems.forEach((item: any, index: number) => {
      const deletePayload: any = {
        qmsReportTemplateSectionFieldVwPk: {
          reportSectionOrFieldId: item.REPORT_SECTION_OR_FIELD_ID
        },
        templateId: this.message.templateIdFromQmsReportTemplate,
        deleteReason: this.deleteFiledValue.value
      };

      this.appService.deleteQmsReportTemplateSectionField(deletePayload).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;

          completed++;

          if (completed === selectedItems.length) {
            this.visibleDeletePopup.close();
            this.ngOnInit();
            this.isProcessing = false;
            this.clearAllSelections();

            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: this.displayResultType === 'S' ? 5000 : undefined,

              data: {
                message: this.displayMessage,
                type: this.displayResultType === 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: this.displayResultType === 'S' ? 'Success' : 'Error',
            });

            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }
        }, error: (error) => {
          this.isProcessing = false;
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          throw error;
        }
      });
    });
  }


  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }
  /* Start QMS Group Detail Type Settings */
  reportFieldTooltipTitle: any;
  getRowData(rowData: any) {
    this.reportFieldTooltipTitle = "Report Template Section Field";
  }
  selectedReportSectionRowData: any;
  openQmsReportFieldPopup(getSectionFieldData: any) {
    this.isProcessing = true;
    this.parentCheckBox = false;
    this.selectedCount = 0;
    this.columnLists.fieldColumnarray = [];
    this.selectedReportSectionRowData = getSectionFieldData;
    this.visibleQmsReportFieldGridPopup = this.dialog.open(this.qmsReportFieldGridPopup, this.addAndEditPopupConfig);
    this.getcallMethod();
  }

  cancelQmsReportFieldGridPopupFunction() {
    this.selectedReportSectionRowData = undefined;
    this.reportFieldTooltipTitle = undefined;
    this.getcallMethod();
    this.visibleQmsReportFieldGridPopup.close();
  }

  refreshQmReportFieldGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(grid: any, viewType: any, report: any) {
    this.auditTrail.report_Id_Audit_Trail = this.templateId;
    this.auditTrail.refNo = viewType == 'overAll' ? null : report.REPORT_SECTION_OR_FIELD_ID;
    this.auditTrail.gridName = grid == 'SECTION' ? 'REPORT_TEMPLATE_SECTION' : 'REPORT_TEMPLATE_SECTION_FIELD';
    this.auditTrail.report_And_Popup_Name = grid == 'SECTION' ? 'Report Template Section Audit Trail' : 'Report Template Section Field Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(report);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(grid: any, reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = grid == 'SECTION' ? 'QMS Report Template Section Report' : 'QMS Report Template Section Field Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild('reorderPopup', { static: true }) reorderPopup: TemplateRef<any>;
  visibleReorderPopup: MatDialogRef<TemplateRef<any>>;

  reorderPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  getClobValue(primeIdentifier: string, columnName: string): Promise<string> {
    const docObj = {

      primeIdentifier: primeIdentifier,
      tableView: 'QMS_REPORT_TEMPLATE_SECTION_VW',
      columnName: columnName
    };

    return new Promise((resolve, reject) => {
      this.appService.getClobToViewAudit(docObj).subscribe({
        next: (response: any) => resolve(response.result),
        error: (error) => {
          console.error('Error fetching CLOB value:', error);
          reject(error);
        },
        complete: () => {
          console.log('CLOB value retrieval completed.');
        }
      });
    });
  }

  reorderTitle: string = ''
  s_or_f: boolean = false;
  isReordered: boolean = false;
  openReorderPopup(reorderFor: string) {
    for (let i = 0; i < this.grid.length; i++) {
      this.grid[i].NEW_ORDER = i + 1;
    }
    this.s_or_f = this.selectedReportSectionRowData;
    this.reorderTitle = reorderFor + ' Reorder';
    this.isReordered = false;
    this.visibleReorderPopup = this.dialog.open(this.reorderPopup, this.reorderPopupConfig);
  }

  cancelReorder() {
    this.visibleReorderPopup.close();
  }

  dragAndDrop(event: CdkDragDrop<string[]>) {
    this.isReordered = true;
    moveItemInArray(this.grid, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.grid.length; i++) {
      this.grid[i].NEW_ORDER = i + 1;
    }
  }

  async reorderSectionOrField() {
    this.isProcessing = true;

    const common_obj = {
      qmsReportTemplateSectionFieldVwPk: {

      },

      templateId: this.message.templateIdFromQmsReportTemplate,
    };

    const promises = [];

    if (this.selectedReportSectionRowData) {
      for (const element of this.grid) {

        const reportSectionHeaderContent = await this.getClobValue(element['PRIM_IDENTIFIER'], 'REPORT_SECTION_HEADER_CONTENT');
        const reportSectionFooterContent = await this.getClobValue(element['PRIM_IDENTIFIER'], 'REPORT_SECTION_FOOTER_CONTENT');

        const field_obj = {
          ...common_obj,
          qmsReportTemplateSectionFieldVwPk: {
            reportSectionOrFieldId: element['REPORT_SECTION_OR_FIELD_ID'],
          },
          reportSectionName: element['REPORT_SECTION_NAME'],
          reportSectionLabelName: element['REPORT_SECTION_LABEL_NAME'],
          reportSectionOrder: element['REPORT_SECTION_ORDER'],
          reportSectionHeaderContent,
          reportSectionFooterContent,
          reportFieldName: element['REPORT_FIELD_NAME'],
          reportFieldLabelName: element['REPORT_FIELD_LABEL_NAME'],
          reportSectionFieldOrder: element['NEW_ORDER'],
          reportSectionFieldAtFullRow: element['REPORT_SECTION_FIELD_AT_FULL_ROW'],
          showOnlyIfNotNull: element['SHOW_ONLY_IF_NOT_NULL'] ? 'Y' : 'N',
          includeExcludeFlag: element['INCLUDE_EXCLUDE_FLAG'] ? 'Y' : 'N',
          isFlexiField: element['IS_FLEXI_FIELD'] ? 'Y' : 'N'
        };
        promises.push(this.executeReorder(field_obj));
      }
    } else {
      for (const element of this.grid) {

        const reportSectionHeaderContent = await this.getClobValue(element['PRIM_IDENTIFIER'], 'REPORT_SECTION_HEADER_CONTENT');
        const reportSectionFooterContent = await this.getClobValue(element['PRIM_IDENTIFIER'], 'REPORT_SECTION_FOOTER_CONTENT');

        const section_obj = {
          ...common_obj,
          qmsReportTemplateSectionFieldVwPk: {

            reportSectionOrFieldId: element['REPORT_SECTION_OR_FIELD_ID'],
          },
          reportSectionName: element['REPORT_SECTION_NAME'],
          reportSectionLabelName: element['REPORT_SECTION_LABEL_NAME'],
          reportSectionOrder: element['NEW_ORDER'],
          reportSectionHeaderContent,
          reportSectionFooterContent,
        };
        promises.push(this.executeReorder(section_obj));
      }
    }

    Promise.all(promises)
      .then(() => {
        let message = this.selectedReportSectionRowData ? 'Report section fields reordered successfully' : 'Report template sections reordered successfully';
        this.isReordered = false;
        this.ngOnInit();
        this.visibleReorderPopup.close();
        this.showSnackBar(message, 'S');
        this.isProcessing = false;
      })
      .catch((error) => {
        this.isProcessing = false;
        console.error('Error reordering fields:', error);
        this.showSnackBar('An error occurred while reordering fields.', 'E');
      });
  }

  executeReorder(obj: {}): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.appService.updateQmsReportTemplateSectionField(obj).subscribe({
        next: (Response: any) => {
          if (Response.resultType === "S") {
            resolve();
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
            reject(new Error(Response.result));
          }
        },
        error: (error) => {
          this.isProcessing = false;
          this.showSnackBar('An error occurred', 'E');
          reject(error);
        }
      });
    });
  }

  snackbarRef: any;

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.selectedReportSectionRowData == undefined ? "REPORT_TEMPLATE_SECTION" : "REPORT_TEMPLATE_SECTION_FIELD",
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  onGroupIdsSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        console.log(this.groupIdsValues);
        this.isFlexiFieldChange();
      })
    }
  }

  selectBoxeForGroupValue() {
    console.log("Starting selectBoxeForGroupValue");
    console.log("Current listOfGroups:", this.listOfGroups);

    this.groupDropdown = [];
    for (const group of this.listOfGroups) {
      const groupOption = {
        valueExp: group.groupId,
        displayExp: group.groupName
      };
      this.groupDropdown.push(groupOption);
      console.log("Added group option:", groupOption);
    }

    // If group name is already selected, find and set the corresponding group ID
    if (!this.visibleGroupName && this.message.groupNameFromQmsReportTemplate) {
      console.log("Looking for group:", this.message.groupNameFromQmsReportTemplate);
      const selectedGroup = this.groupDropdown.find(
        (group: any) => group.displayExp === this.message.groupNameFromQmsReportTemplate
      );
      if (selectedGroup) {
        this.groupIdsValues = [selectedGroup.valueExp];
        console.log("Found and set group value:", this.groupIdsValues);
      } else {
        console.log("No matching group found in dropdown");
      }
    }

    console.log("Final groupDropdown:", this.groupDropdown);
    console.log("Final groupIdsValues:", this.groupIdsValues);
  }
  columnNameList: any = [];
  columnListDropdown: any = [];
  dynamicFieldCall(val: any, module: any) {
    this.isProcessing = true;
    let tableName = "";
    let gridName = "";
    if (module == 'CR' && (val == 'Change Request' || val == 'Change Request Details')) {
      tableName = "QMS_CR_GRID_VW";
      gridName = "CR";
    } else if (module == 'CAPA' && (val == 'CAPA' || val == 'CAPA Details')) {
      tableName = "QMS_CAPA_GRID_VW";
      gridName = "CAPA";
    } else if (module == 'DV' && (val == 'Deviation' || val == 'Deviation Details' || val == 'Investigation')) {
      tableName = "QMS_DV_GRID_VW";
      gridName = "DV";
    } else if (module == 'IN' && (val == 'Details' || val == 'Incident Logging' || val == 'Investigation' || val == 'Complete Incident')) {
      tableName = "QMS_IN_GRID_VW";
      gridName = "IN";
    } else if (module == 'QI' && (val == 'Details' || val == 'Quality Issue Logging' || val == 'Investigation' || val == 'Complete Quality Issue')) {
      tableName = "QMS_QI_GRID_VW";
      gridName = "QI";
    } else if (module == 'CC' && (val == 'Complainant / Reporter Details' || val == 'Complaint Identification' || val == 'Investigation' || val == 'Final Evaluation' || val == 'Reimbursement' || val == 'Response')) {
      tableName = "QMS_CC_GRID_VW";
      gridName = "CC";
    } else if (val === 'Audit Details' || val === 'Audit Conduct Summary') {
      tableName = "QMS_AU_CONDUCT_VW";
      gridName = "AU_CONDUCT";

    } else if (module == 'OOS' && (val == 'Actions')) {
      tableName = "QMS_OOS_ACTIONS_VW";
      gridName = "OOS_ACTIONS";
    } else if (val == 'Actions') {
      tableName = "QMS_ACTIONS_VW";
      gridName = "ACTIONS";
    } else if (val == 'Pre Actions') {
      tableName = "QMS_PRE_ACTIONS_VW";
      gridName = "PRE_ACTIONS";
    } else if (val == 'Risk Management') {
      tableName = "QMS_RISKS_VW";
      gridName = "RISKS";
    }
    else if (val == 'History') {
      tableName = "ONEQMS_TASK_ACTIONS_HISTORY_VW";
      gridName = "TASK_HISTORY";
    } else if (val == 'Action Documents' || val == 'Documents' || val == 'Documents') {
      tableName = "QMS_TASK_DOCUMENTS_VW";
      gridName = "DOCUMENT";
    } else if (val == 'Effectiveness Check Document' || val == 'EC Documents' || val == 'EC Document') {
      tableName = "QMS_TASK_EC_DOCUMENTS_VW";
      gridName = "EC_DOCUMENT";
    } else if (val == 'Effectiveness Check') {
      tableName = "QMS_TASK_EC_VW";
      gridName = "EC";
    } else if (val == 'EC Action' || val == 'Effectiveness Check Action') {
      tableName = "QMS_TASK_ACTION_EC_VW";
      gridName = "EC_ACTION";
    } else if (val == 'EC participants' || val == 'Effectiveness Check participants') {
      tableName = "QMS_TASK_EC_PARTICIPANTS_VW";
      gridName = "EC_PARTICIPANT";
    } else if (val == 'Extension') {
      tableName = "QMS_TASK_EXTENSIONS_VW";
      gridName = "EXTENSION";
      module = module == 'OOS' ? null : module;
    } else if (val == 'Dependency') {
      tableName = "QMS_TASK_DEPENDENCIES_VW";
      gridName = "DEPENDENCY";
    } else if (val == 'Investigation Persons') {
      tableName = "QMS_DV_PARTICIPANTS_VW";
      gridName = "REPORT_DV_PARTICIPANTS";
    } else if (val == 'Products') {
      tableName = "QMS_CCP_VW";
      gridName = "CCP";
    } else if (val == 'Questionnaire') {
      tableName = "QMS_AU_QUESTIONS_VW";
      gridName = "AU_QUESTIONS";
    } else if (val == 'Participants') {
      tableName = "QMS_AU_PARTICIPANTS_VW";
      gridName = "AU_PARTICIPANTS";
    } else if (val == 'Findings') {
      tableName = "QMS_AU_FINDINGS_VW";
      gridName = "AU_FINDINGS";
    } else if (val == 'Follow Ups') {
      tableName = "QMS_AU_FOLLOWUPS_VW";
      gridName = "AU_FOLLOWUPS";
    } else if (val == 'Recommendations') {
      tableName = "QMS_AU_RECOMMENDATIONS_VW";
      gridName = "AU_RECOMMENDATIONS";
    } else if (val == 'Audit Schedule') {
      tableName = "QMS_AU_SCHEDULE_VW";
      gridName = "AU_SCHEDULE";
    } else if (val == 'Audit Plan') {
      tableName = "QMS_AU_PLAN_VW";
      gridName = "AU_PLAN";
    } else if ((module == 'OOS' && (val == 'OOS Details' || val == 'Preliminary Actions' || val == 'Data Evaluation' || val == 'Batch Disposition & Closure')) || (module == 'OOS' && (val == 'PhaseII' || val == 'PhaseIII' || val == 'Observed Results' || val == 'Laboratory Investigations' || val == 'Signatories' || val == 'Location Details' || val == 'Description' || val == 'Test Details' || val == 'Instrument Details'))) {
      tableName = "QMS_OOS_GRID_VW";
      gridName = "OOS";
    } else if (val == 'Impact Assessment') {
      tableName = "QMS_IMPACT_ASSESSMENT_VW";
      gridName = "IMPACT_ASSESSMENT";

    } else if (val == 'ClosureApprover' || val == 'ClosureReviewer' || val == 'Reviewer' || val == 'Approver' || val == 'Closure Reviewer' || val == 'Closure Approver' || val == 'Peer Review' || val == 'Closure Approve' || val == 'Closure Review' || val == 'PhaseII Approver' || val == 'PhaseIII Approver' || val == 'PhaseII Reviewer' || val == 'PhaseIII Reviewer') {

      tableName = "ONEQMS_TASK_STAGE_USERS_VW";
      gridName = "TASK_STAGE_USERS";
    }
    const data = {
      tableName: tableName,
      moduleName: module,
      gridName: gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.columnNameList = data;
        this.selectBoxeForColumnsValue();
        console.log("this.columnNameList=", this.columnNameList);
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  selectBoxeForColumnsValue() {
    this.columnListDropdown = [];

    const validSections = [
      'ClosureApprover',
      'ClosureReviewer',
      'Reviewer',
      'Approver',
      'Closure Reviewer',
      'Closure Approver',
      'Peer Review',
      'Closure Approve',
      'Closure Review',
      'PhaseII Approver',
      'PhaseIII Approver',
      'PhaseII Reviewer',
      'PhaseIII Reviewer'
    ];
    const validSections1 = [
      'Action Documents'
    ];

    const validSections2 = [
      'Check List'
    ];
    if (validSections.includes(this.selectedReportSectionRowData.REPORT_SECTION_NAME)) {
      const dropdownItems = [
        { valueExp: 'User', displayExp: 'User' },
        { valueExp: 'Document Added', displayExp: 'Document Added' },
        { valueExp: 'USER_LEVEL', displayExp: 'USER_LEVEL' },
        { valueExp: 'USER_ROLE', displayExp: 'USER_ROLE' },
        { valueExp: 'STATUS', displayExp: 'STATUS' },
        { valueExp: 'REQUESTED_ON', displayExp: 'REQUESTED_ON' },
        { valueExp: 'COMPLETED_ON', displayExp: 'COMPLETED_ON' },
        { valueExp: 'REASON_FOR_SIGNATURE', displayExp: 'REASON_FOR_SIGNATURE' },
        { valueExp: 'COMMENTS', displayExp: 'COMMENTS' }
      ];

      this.set(dropdownItems);
    } else if (validSections1.includes(this.selectedReportSectionRowData.REPORT_SECTION_NAME)) {
      const dropdownItems = [
        { valueExp: 'Evidence Attached', displayExp: 'Evidence Attached' },
        { valueExp: 'DOCUMENT_TYPE', displayExp: 'DOCUMENT_TYPE' },
        { valueExp: 'DOCUMENT_NAME', displayExp: 'DOCUMENT_NAME' },
        { valueExp: 'COMMENTS', displayExp: 'COMMENTS' },
      ];

      this.set(dropdownItems);
    } else if (validSections2.includes(this.selectedReportSectionRowData.REPORT_SECTION_NAME)) {
      const dropdownItems = [
        { valueExp: 'FIELD_SEQ', displayExp: 'FIELD_SEQ' },
        { valueExp: 'FIELD_NAME', displayExp: 'FIELD_NAME' },
        { valueExp: 'RESPONSE', displayExp: 'RESPONSE' },
        { valueExp: 'JUSTIFICATION', displayExp: 'JUSTIFICATION' },
      ];

      this.set(dropdownItems);
    } else {

      const gridColumns = this.grid.map((g: any) => g.REPORT_FIELD_NAME);
      const gridSet = new Set(gridColumns);
      const x = this.columnNameList.filter((c: any) => {
        const exists = gridSet.has(c.columnName);
        return !exists;
      });

      this.columnListDropdown = x.map((c: any) => ({
        valueExp: c.columnName,
        displayExp: c.columnName
      }));
    }
  }

  set(array: any) {
    const gridColumns = this.grid.map((g: any) => g.REPORT_FIELD_NAME);
    const gridSet = new Set(gridColumns);
    const x = array.filter((c: any) => {
      const exists = gridSet.has(c.valueExp);
      return !exists;
    });

    this.columnListDropdown = x;
  }

  selectBoxeForColumnsValueFlexiFields() {
    const gridColumns = this.grid.map((g: any) => g.REPORT_FIELD_NAME);
    const gridSet = new Set(gridColumns);
    const x = this.columnNameList.filter((c: any) => {
      const exists = gridSet.has(c.columnName);
      return !exists;
    });

    this.columnListDropdown = x.map((c: any) => ({
      valueExp: c.columnName,
      displayExp: c.columnName + ' - ' + c.fieldName
    }));
  }

  onColumnsValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      console.log(item.valueExp);
    }
  }

  isFlexiFieldChange() {
    console.log("this.qmsReportTemplateSectionFieldData.isFlexiField", this.qmsReportTemplateSectionFieldData.isFlexiField);
    this.columnListDropdown = [];
    let tableName = "";
    let gridName = "";
    let val = this.selectedReportSectionRowData.REPORT_SECTION_NAME;
    let module = this.message.moduleFromQmsReportTemplate;

    // Handle group name visibility and selection
    if (this.qmsReportTemplateSectionFieldData.isFlexiField) {
      if (!this.visibleGroupName && this.message.groupNameFromQmsReportTemplate) {
        // If group name is not visible (meaning it's already selected)
        // Find and set the group ID from the group name
        const selectedGroup = this.groupDropdown.find(
          (group: any) => group.displayExp === this.message.groupNameFromQmsReportTemplate
        );
        if (selectedGroup) {
          this.groupIdsValues = [selectedGroup.valueExp];
        }
      }
    } else {
      this.groupIdsValues = [];
    }

    if (this.qmsReportTemplateSectionFieldData.isFlexiField) {
      let gIds = null;
      if (this.groupIdsValues) {
        if (this.groupIdsValues.length != 0) {
          for (let i = 0; i < this.groupIdsValues.length; i++) {
            if (i == 0) {
              gIds = this.groupIdsValues[i].toString();
            } else {
              gIds = gIds + "," + this.groupIdsValues[i].toString();
            }
          }
        }
      }
      const data = {
        moduleName: module,
        groupId: gIds ?? '0',
      };
      this.appService.getreorderGirdColumnListForFlexiField(data).subscribe({
        next: (data: any) => {
          this.columnNameList = data;
          this.selectBoxeForColumnsValueFlexiFields();
          console.log("this.columnNameList=", this.columnNameList);
          this.isProcessing = false;
        }, error: (error: any) => {
          this.isProcessing = false;
        }
      });
    } else {
      this.isProcessing = true;
      if (module == 'CR' && (val == 'Change Request' || val == 'Change Request Details')) {
        tableName = "QMS_CR_GRID_VW";
        gridName = "CR";
      } else if (module == 'CAPA' && (val == 'CAPA' || val == 'CAPA Details')) {
        tableName = "QMS_CAPA_GRID_VW";
        gridName = "CAPA";
      } else if (module == 'DV' && (val == 'Deviation' || val == 'Deviation Details' || val == 'Investigation')) {
        tableName = "QMS_DV_GRID_VW";
        gridName = "DV";
      } else if (module == 'IN' && (val == 'Details' || val == 'Incident Logging' || val == 'Investigation' || val == 'Complete Incident')) {
        tableName = "QMS_IN_GRID_VW";
        gridName = "IN";
      } else if (module == 'QI' && (val == 'Details' || val == 'Quality Issue Logging' || val == 'Investigation' || val == 'Complete Quality Issue')) {
        tableName = "QMS_QI_GRID_VW";
        gridName = "QI";
      } else if (module == 'CC' && (val == 'Complainant / Reporter Details' || val == 'Complaint Identification' || val == 'Investigation' || val == 'Final Evaluation' || val == 'Reimbursement' || val == 'Response')) {
        tableName = "QMS_CC_GRID_VW";
        gridName = "CC";
      } else if (val == 'Audit Details' || val == 'Audit Conduct Summary') {
        tableName = "QMS_AU_CONDUCT_VW";
        gridName = "AU_CONDUCT";
      } else if (val == 'Audit Schedule') {
        tableName = "QMS_AU_SCHEDULE_VW";
        gridName = "AU_SCHEDULE";
      } else if (module == 'OOS' && (val == 'Actions')) {
        tableName = "QMS_OOS_ACTIONS_VW";
        gridName = "OOS_ACTIONS";
      } else if (val == 'Actions') {
        tableName = "QMS_ACTIONS_VW";
        gridName = "ACTIONS";
      } else if (val == 'Pre Actions') {
        tableName = "QMS_PRE_ACTIONS_VW";
        gridName = "PRE_ACTIONS";
      } else if (val == 'Risk Management') {
        tableName = "QMS_RISKS_VW";
        gridName = "RISKS";
      }
      else if (val == 'History') {
        tableName = "ONEQMS_TASK_ACTIONS_HISTORY_VW";
        gridName = "TASK_HISTORY";
      } else if (val == 'Action Documents' || val == 'Documents') {
        tableName = "QMS_TASK_DOCUMENTS_VW";
        gridName = "DOCUMENT";
      } else if (val == 'Effectiveness Check') {
        tableName = "QMS_TASK_EC_VW";
        gridName = "EC";
      } else if (val == 'EC Action' || val == 'Effectiveness Check Action') {
        tableName = "QMS_TASK_ACTION_EC_VW";
        gridName = "EC_ACTION";
      } else if (val == 'EC participants' || val == 'Effectiveness Check participants') {
        tableName = "QMS_TASK_EC_PARTICIPANTS_VW";
        gridName = "EC_PARTICIPANT";
      } else if (val == 'Effectiveness Check Document' || val == 'EC Document' || val == 'EC Documents') {
        tableName = "QMS_TASK_EC_DOCUMENTS_VW";
        gridName = "EC_DOCUMENT";
      } else if (val == 'Extension') {
        tableName = "QMS_TASK_EXTENSIONS_VW";
        gridName = "EXTENSION";
        module = module == 'OOS' ? null : module;
      } else if (val == 'Dependency') {
        tableName = "QMS_TASK_DEPENDENCIES_VW";
        gridName = "DEPENDENCY";
      } else if (val == 'Investigation Persons') {
        tableName = "QMS_DV_PARTICIPANTS_VW";
        gridName = "REPORT_DV_PARTICIPANTS";
      } else if (val == 'Products') {
        tableName = "QMS_CCP_VW";
        gridName = "CCP";
      } else if (val == 'Questionnaire') {
        tableName = "QMS_AU_QUESTIONS_VW";
        gridName = "AU_QUESTIONS";
      } else if (val == 'Participants') {
        tableName = "QMS_AU_PARTICIPANTS_VW";
        gridName = "AU_PARTICIPANTS";
      } else if (val == 'Findings') {
        tableName = "QMS_AU_FINDINGS_VW";
        gridName = "AU_FINDINGS";
      } else if (val == 'Follow Ups') {
        tableName = "QMS_AU_FOLLOWUPS_VW";
        gridName = "AU_FOLLOWUPS";
      } else if (val == 'Recommendations') {
        tableName = "QMS_AU_RECOMMENDATIONS_VW";
        gridName = "AU_RECOMMENDATIONS";
      } else if (val == 'Audit Plan') {
        tableName = "QMS_AU_PLAN_VW";
        gridName = "AU_PLAN";
      } else if (module == 'OOS' && ((val == 'OOS Details' || val == 'Preliminary Actions' || val == 'Data Evaluation' || val == 'Batch Disposition & Closure') || (val == 'PhaseII' || val == 'PhaseIII' || val == 'Observed Results' || val == 'Laboratory Investigations' || val == 'Signatories' || val == 'Location Details' || val == 'Description' || val == 'Test Details' || val == 'Instrument Details'))
      ) {
        tableName = "QMS_OOS_GRID_VW";
        gridName = "OOS";
      } else if (val == 'Impact Assessment') {
        tableName = "QMS_IMPACT_ASSESSMENT_VW";
        gridName = "IMPACT_ASSESSMENT";

      } else if (val == 'ClosureApprover' || val == 'ClosureReviewer' || val == 'Reviewer' || val == 'Approver' || val == 'Closure Reviewer' || val == 'Closure Approver' || val == 'Peer Review' || val == 'Closure Approve' || val == 'Closure Review' || val == 'PhaseII Approver' || val == 'PhaseIII Approver' || val == 'PhaseII Reviewer' || val == 'PhaseIII Reviewer') {

        tableName = "ONEQMS_TASK_STAGE_USERS_VW";
        gridName = "TASK_STAGE_USERS";
      }

      const data = {
        tableName: tableName,
        moduleName: module,
        gridName: gridName,
        groupId: 0,
      };
      this.appService.getreorderGirdColumnList(data).subscribe({
        next: (data: any) => {
          this.columnNameList = data;
          this.selectBoxeForColumnsValue();
          console.log("this.columnNameList=", this.columnNameList);
          this.isProcessing = false;
        }, error: (error: any) => {
          this.isProcessing = false;
        }
      });
    }
  }

  dynamicSectionlist() {
    const scetionMapping: Record<string, any> = {
      'CR': this.sectionListCR, 'CAPA': this.sectionListCAPA, 'DV': this.sectionListDV,
      'IN': this.sectionListQI, 'QI': this.sectionListQI, 'CC': this.sectionListCC,
      'AU': this.sectionListAU, 'AU-PLAN': this.sectionListAUPlan, 'AU-Schedule': this.sectionListAUSchudule, 'AU-Finding': this.sectionListAUFinding
    };
    const gridColumns = this.grid.map((g: any) => g.REPORT_SECTION_NAME);
    const gridSet = new Set(gridColumns);
    const x = scetionMapping[this.message.moduleFromQmsReportTemplate == 'AU' ? this.message.subModule : this.message.moduleFromQmsReportTemplate].filter((c: string) => !gridSet.has(c));
    this.sectionList = x.map((c: string) => ({ valueExp: c, displayExp: c }));
  }
}
